// extracted by mini-css-extract-plugin
var _1 = "SenderMailboxField-moduleSenderMailboxField__G08yr";
var _2 = "SenderMailboxField-moduleline__JZgUe";
export { _1 as "SenderMailboxField", _2 as "line" }
